export const parseDate = date => new Date(date)

export const nowISOString = () => (new Date()).toISOString();

export const nowDate = () => new Date();

export const dateRangeOverlap = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || !e2 || new Date(s1) <= new Date(e2)) &&
           (!s2 || !e1 || new Date(s2) <= new Date(e1));
}

export const dateRangeOverlapExclusive = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || !e2 || new Date(s1) < new Date(e2)) &&
           (!s2 || !e1 || new Date(s2) < new Date(e1));
}

export const dateRangeIncludes = ({ start: s1, end: e1 }, { start: s2, end: e2 }) => {
    return (!s1 || new Date(s1) <= new Date(s2)) &&
           (!e1 || new Date(e1) >= new Date(e2));
}

export const minDate = (list, field) => {
    let minEntry = null;
    let minValue = null;

    for (const entry of list) {
        const value = field !== undefined ? entry[field] : entry;
        const date = new Date(value);
        if (value && (!minValue || date < minValue)) {
            minValue = date;
            minEntry = value;
        }
    }

    return minEntry;
};

export const maxDate = (list, field) => {
    let maxEntry = null;
    let maxValue = null;

    for (const entry of list) {
        const value = field !== undefined ? entry[field] : entry;
        const date = new Date(value);
        if (value && (!maxValue || date > maxValue)) {
            maxValue = date;
            maxEntry = value;
        }
    }

    return maxEntry;
};

export const dateSameOrAfter = ({start: s1}, {start: s2}) => {
    return parseDate(s2) >= parseDate(s1);
}

export const dateInRangeInclusive = (date, { start, end }) => {
    const d = new Date(date);
    return d >= new Date(start) && d <= new Date(end);
};

export const dateInRangeExclusive = (date, { start, end }) => {
    const d = new Date(date);
    return d >= new Date(start) && d < new Date(end);
}